var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "tabs",
              { staticClass: "tabs-default" },
              [
                _c("tab", { attrs: { id: "venta", name: "Venta" } }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Fecha")]),
                            _vm._v(" "),
                            _c("datepicker", {
                              attrs: {
                                format: _vm.format,
                                "input-class": "form-control",
                                language: _vm.es
                              },
                              model: {
                                value: _vm.saleDate,
                                callback: function($$v) {
                                  _vm.saleDate = $$v
                                },
                                expression: "saleDate"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Localidad")]),
                            _vm._v(" "),
                            _c("multi-select", {
                              attrs: {
                                options: _vm.places,
                                "allow-empty": false,
                                "show-labels": false,
                                searchable: true,
                                label: "name",
                                "track-by": "id",
                                placeholder: "Seleccione una localidad"
                              },
                              model: {
                                value: _vm.place,
                                callback: function($$v) {
                                  _vm.place = $$v
                                },
                                expression: "place"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-4" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Cliente")]),
                            _vm._v(" "),
                            _c(
                              "multi-select",
                              {
                                attrs: {
                                  options: _vm.clients,
                                  "allow-empty": false,
                                  "show-labels": false,
                                  searchable: true,
                                  label: "name",
                                  "track-by": "name",
                                  placeholder: "Seleccione un cliente",
                                  "internal-search": false,
                                  loading: _vm.isLoadingClients,
                                  "custom-label": _vm.nameWithNit
                                },
                                on: { "search-change": _vm.searchClients },
                                model: {
                                  value: _vm.client,
                                  callback: function($$v) {
                                    _vm.client = $$v
                                  },
                                  expression: "client"
                                }
                              },
                              [
                                _c("template", { slot: "beforeList" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-success btn-lg btn-block",
                                      on: { click: _vm.openModalClient }
                                    },
                                    [
                                      _vm._v("Nuevo Cliente "),
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-plus"
                                      })
                                    ]
                                  )
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Crédito autorizado")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.client.credit_limit,
                                expression: "client.credit_limit"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", readonly: "true" },
                            domProps: { value: _vm.client.credit_limit },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.client,
                                  "credit_limit",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-3" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Documento")]),
                            _vm._v(" "),
                            _c("multi-select", {
                              attrs: {
                                options: _vm.documents,
                                "allow-empty": false,
                                "show-labels": false,
                                label: "name",
                                "track-by": "id",
                                placeholder: "Seleccione un documento",
                                loading: _vm.isLoadingDocuments
                              },
                              on: {
                                input: function($event) {
                                  return _vm.getCorrelative(_vm.document.name)
                                }
                              },
                              model: {
                                value: _vm.document,
                                callback: function($$v) {
                                  _vm.document = $$v
                                },
                                expression: "document"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Serie")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.correlative,
                                  expression: "correlative",
                                  modifiers: { number: true }
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "number",
                                "aria-label": "Recipient's username",
                                "aria-describedby": "basic-addon2"
                              },
                              domProps: { value: _vm.correlative },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.correlative = _vm._n($event.target.value)
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: "Obtener correlativo",
                                        classes: ["info"],
                                        targetClasses: ["it-has-a-tooltip"],
                                        offset: 30
                                      },
                                      expression:
                                        "{\n                        content: 'Obtener correlativo',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 30,\n                      }"
                                    }
                                  ],
                                  staticClass: "btn btn-outline-primary",
                                  attrs: {
                                    disabled: _vm.isLoadingCorrelative,
                                    type: "button"
                                  },
                                  on: { click: _vm.getCorrelative }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-undo"
                                  })
                                ]
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Productos")]),
                            _vm._v(" "),
                            _c("multi-select", {
                              ref: "products",
                              attrs: {
                                options: _vm.products,
                                "allow-empty": false,
                                "show-labels": false,
                                searchable: true,
                                label: "name",
                                "track-by": "name",
                                placeholder: "Seleccione sus productos",
                                "internal-search": false,
                                loading: _vm.isLoadingProducts,
                                "custom-label": _vm.nameWithCode
                              },
                              on: {
                                "search-change": _vm.searchProducts,
                                close: _vm.addProduct
                              },
                              model: {
                                value: _vm.product,
                                callback: function($$v) {
                                  _vm.product = $$v
                                },
                                expression: "product"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-1" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Agregar")]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success btn-block",
                              on: { click: _vm.addProduct }
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Productos")]),
                            _vm._v(" "),
                            _c(
                              "table-component",
                              {
                                attrs: {
                                  data: _vm.selectProducts,
                                  "table-class": "table",
                                  "show-filter": false
                                }
                              },
                              [
                                _c("table-column", {
                                  attrs: { show: "code", label: "Código" }
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    show: "nameProduct",
                                    label: "Producto"
                                  }
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: { show: "stock", label: "Existencia" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.myquantity(row["stock"])
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    show: "sales_price",
                                    label: "Precio"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.mymoney(row["sales_price"])
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Cantidad"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value:
                                                  _vm.selectProducts[
                                                    _vm.getIndex(
                                                      _vm.selectProducts,
                                                      row["id"]
                                                    )
                                                  ].quantity,
                                                expression:
                                                  "selectProducts[getIndex(selectProducts,row['id'])].quantity",
                                                modifiers: { number: true }
                                              }
                                            ],
                                            ref:
                                              "quantity-" +
                                              _vm.getIndex(
                                                _vm.selectProducts,
                                                row["id"]
                                              ),
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid":
                                                _vm.selectProducts[
                                                  _vm.getIndex(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  )
                                                ].error === true
                                            },
                                            attrs: { type: "number" },
                                            domProps: {
                                              value:
                                                _vm.selectProducts[
                                                  _vm.getIndex(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  )
                                                ].quantity
                                            },
                                            on: {
                                              blur: [
                                                function($event) {
                                                  _vm.validateQuantity(
                                                    _vm.getIndex(
                                                      _vm.selectProducts,
                                                      row["id"]
                                                    )
                                                  )
                                                },
                                                function($event) {
                                                  return _vm.$forceUpdate()
                                                }
                                              ],
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                _vm.refMultiple(
                                                  "quantity",
                                                  _vm.getIndexPlus(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  )
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.selectProducts[
                                                    _vm.getIndex(
                                                      _vm.selectProducts,
                                                      row["id"]
                                                    )
                                                  ],
                                                  "quantity",
                                                  _vm._n($event.target.value)
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Descuento"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-prepend"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectProducts[
                                                              _vm.getIndex(
                                                                _vm.selectProducts,
                                                                row["id"]
                                                              )
                                                            ].typeDiscount,
                                                          expression:
                                                            "selectProducts[getIndex(selectProducts,row['id'])].typeDiscount"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        disabled:
                                                          _vm.discountSetting
                                                      },
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              _vm
                                                                .selectProducts[
                                                                _vm.getIndex(
                                                                  _vm.selectProducts,
                                                                  row["id"]
                                                                )
                                                              ],
                                                              "typeDiscount",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function($event) {
                                                            _vm.changeDiscount(
                                                              _vm.getIndex(
                                                                _vm.selectProducts,
                                                                row["id"]
                                                              )
                                                            )
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "Q",
                                                            title: "Quetzales"
                                                          }
                                                        },
                                                        [_vm._v("Q")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "%",
                                                            title: "Porcentaje"
                                                          }
                                                        },
                                                        [_vm._v("%")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.number",
                                                    value:
                                                      _vm.selectProducts[
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      ].discount,
                                                    expression:
                                                      "selectProducts[getIndex(selectProducts,row['id'])].discount",
                                                    modifiers: { number: true }
                                                  }
                                                ],
                                                ref:
                                                  "discount-" +
                                                  _vm.getIndex(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  ),
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "number",
                                                  readonly: _vm.discountSetting
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.selectProducts[
                                                      _vm.getIndex(
                                                        _vm.selectProducts,
                                                        row["id"]
                                                      )
                                                    ].discount
                                                },
                                                on: {
                                                  blur: [
                                                    function($event) {
                                                      _vm.validateQuantity(
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  ],
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    _vm.refMultiple(
                                                      "discount",
                                                      _vm.getIndexPlus(
                                                        _vm.selectProducts,
                                                        row["id"]
                                                      )
                                                    )
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.selectProducts[
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      ],
                                                      "discount",
                                                      _vm._n(
                                                        $event.target.value
                                                      )
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Subtotal"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.mymoney(row["subtotal"])
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("table-column", {
                                  attrs: {
                                    sortable: false,
                                    filterable: false,
                                    label: "Acciones"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(row) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "btn-group mr-2",
                                              attrs: {
                                                role: "group",
                                                "aria-label": "First group"
                                              }
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName:
                                                        "v-tooltip.top-center",
                                                      value: "Quitar producto",
                                                      expression:
                                                        "'Quitar producto'",
                                                      modifiers: {
                                                        "top-center": true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "btn btn-danger",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.removeProduct(
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-trash"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.selectProducts[
                                                      _vm.getIndex(
                                                        _vm.selectProducts,
                                                        row["id"]
                                                      )
                                                    ].state === 1
                                                      ? "btn btn-success"
                                                      : "btn btn-danger"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.facturaono(
                                                        _vm.selectProducts[
                                                          _vm.getIndex(
                                                            _vm.selectProducts,
                                                            row["id"]
                                                          )
                                                        ].state
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "tfoot" }, [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-right",
                                        attrs: { colspan: "6" }
                                      },
                                      [
                                        _c(
                                          "h6",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v("Total")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("th", [
                                      _c(
                                        "h6",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v(_vm._s(_vm.mymoney(_vm.total)))]
                                      )
                                    ])
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-9" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Comentario")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.description,
                                expression: "description"
                              }
                            ],
                            ref: "description",
                            staticClass: "form-control",
                            attrs: { placeholder: "Comentario sobre la venta" },
                            domProps: { value: _vm.description },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.changeRef("buttonSave")
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.description = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-3" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              ref: "buttonSave",
                              staticClass:
                                "btn btn-block btn-theme ladda-button",
                              attrs: {
                                slot: "button",
                                "data-style": "expand-right"
                              },
                              on: {
                                click: _vm.openModalReferenceClient,
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.openModalReferenceClient.apply(
                                    null,
                                    arguments
                                  )
                                }
                              },
                              slot: "button"
                            },
                            [_vm._v("Guardar venta")]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "modal_client",
          attrs: {
            title: "Nuevo cliente",
            "hide-close-button": "",
            blocking: ""
          },
          on: {
            close: _vm.closeModalClient,
            open: function($event) {
              return _vm.changeRef("nameClient")
            }
          }
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nit cliente")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.clientNit,
                    expression: "clientNit",
                    modifiers: { trim: true }
                  }
                ],
                ref: "nitClient",
                staticClass: "form-control",
                class: { "is-invalid": _vm.$v.clientNit.$error },
                attrs: { placeholder: "C/F" },
                domProps: { value: _vm.clientNit },
                on: {
                  blur: [
                    function($event) {
                      return _vm.$v.clientNit.$touch()
                    },
                    function($event) {
                      return _vm.$forceUpdate()
                    }
                  ],
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changeRef("nameClient")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.clientNit = $event.target.value.trim()
                  }
                }
              }),
              _vm._v(" "),
              _vm.$v.clientNit.$error
                ? _c("div", [
                    !_vm.$v.clientNit.nit
                      ? _c(
                          "span",
                          { staticClass: "help-block help-block-error" },
                          [_vm._v("El número de nit no es válido.")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.clientName,
                    expression: "clientName",
                    modifiers: { trim: true }
                  }
                ],
                ref: "nameClient",
                staticClass: "form-control",
                class: { "is-invalid": _vm.$v.clientName.$error },
                domProps: { value: _vm.clientName },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changeRef("addressClient")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.clientName = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Dirección")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.clientAddress,
                    expression: "clientAddress",
                    modifiers: { trim: true }
                  }
                ],
                ref: "addressClient",
                staticClass: "form-control",
                class: { "is-inva/lid": _vm.$v.clientAddress.$error },
                domProps: { value: _vm.clientAddress },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changeRefVue("telephoneClient")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.clientAddress = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Teléfono")]),
                _vm._v(" "),
                _c("masked-input", {
                  ref: "telephoneClient",
                  staticClass: "form-control",
                  attrs: {
                    mask: [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
                    guide: false,
                    "keep-char-positions": true,
                    "show-mask": true
                  },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.changeRef("clientSave")
                    }
                  },
                  model: {
                    value: _vm.clientTelephone,
                    callback: function($$v) {
                      _vm.clientTelephone = $$v
                    },
                    expression: "clientTelephone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: { slot: "button", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$refs.modal_client.close()
                }
              },
              slot: "button"
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              ref: "clientSave",
              staticClass: "btn btn-primary ladda-button",
              attrs: {
                slot: "button",
                type: "button",
                "data-style": "expand-right"
              },
              on: { click: _vm.saveClient },
              slot: "button"
            },
            [_vm._v("Guardar")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "modal_client_reference",
          attrs: {
            title: "Nombre del cliente",
            "hide-close-button": "",
            blocking: ""
          }
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre del cliente")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nameReference,
                    expression: "nameReference"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.nameReference },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.nameReference = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: { slot: "button", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$refs.modal_client_reference.close()
                }
              },
              slot: "button"
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              ref: "clientSave",
              staticClass: "btn btn-primary ladda-button",
              attrs: {
                slot: "button",
                type: "button",
                "data-style": "expand-right"
              },
              on: { click: _vm.validateRefernceClient },
              slot: "button"
            },
            [_vm._v("Guardar")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Nueva venta")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Ventas")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Nueva venta")
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4df14380", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df14380","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/sale/Sale.vue
// module id = 617
// module chunks = 0